module.exports = __webpack_public_path__ + "static/img/role.2bb82db.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/oo/role.png
// module id = xOVM
// module chunks = 7